var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCampaignRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 68,
    viewBox: "0 0 203 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.378 0C195.214 0 202.378 7.16344 202.378 16L202.378 68C202.378 68 199.99 56.3981 182.795 56.3981H0L28.3778 27.0711L0 0L186.378 0Z",
    fill: "url(#paint0_linear_10873_9153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10873_9153",
    x1: -33.1222,
    y1: -15,
    x2: 202.378,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62191,
    stopColor: "#D80213"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignRibbon);
export default __webpack_public_path__ + "static/media/campaignRibbon.1a629444e3664d61173747cf58a67382.svg";
export { ForwardRef as ReactComponent };